import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './App.css';
import AppRoot from './app/AppRoot';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root is missing from index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <AppRoot />
  </StrictMode>
);
